import { ICertificationsDto, IExperiencesDto, IHardSkillsDto, ILanguagesDto, ISoftSkillsDto } from "../../../../@types/curriculum.type";
import Tooltip from "@mui/material/Tooltip/Tooltip";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useEffect, useState } from "react";

interface SkillsProps {
  changedSkills: IHardSkillsDto[] | ISoftSkillsDto[] | IExperiencesDto[] | ICertificationsDto[] | ILanguagesDto[];
  changed: boolean;
  setValue: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SkillChangeWarning: React.FC<SkillsProps> = ({
  changedSkills,
  changed,
  setValue
}) => {
  const [hasChangeSkill, setHasChangeSkill] = useState<boolean>(false);
  const [initialSkills, setInitialSkills] = useState<IHardSkillsDto[] | ISoftSkillsDto[] | IExperiencesDto[] | ICertificationsDto[] | ILanguagesDto[]>([]);

  function areArraysEqual(arr1: any[], arr2: any[]): boolean {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  }

  useEffect(() => {
    setInitialSkills(changedSkills);
  }, [])

  useEffect(() => {
    if(changed){
      setInitialSkills(changedSkills);
      setValue(false);
    }
  }, [changed])
  
  useEffect(() => {
    if (!areArraysEqual(initialSkills, changedSkills))
      setHasChangeSkill(true);
    else 
      setHasChangeSkill(false);
  }, [changedSkills, initialSkills]);


  return (
    <>
      {hasChangeSkill && (
        <Tooltip title="Há modificações feitas não salvas" arrow>
          <WarningAmberIcon color="warning" />
        </Tooltip>
      )}
    </>
  );
};
